
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/near-by",
      function () {
        return require("private-next-pages/near-by.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/near-by"])
      });
    }
  